import { RootState } from '@/stores'
import { useSelector } from 'react-redux'
import ConcreteProperties from './properties/ConcreteProperties'
import CastInAnchorChannelProperties from './properties/CastInAnchorChannelProperties'
import TboltProperties from './properties/TboltProperties'
import { useGetProductVariantsQuery, useGetProductsQuery } from '@/api/serverApi'
import { LoadingSpinner } from '@cfs-fixings/shared'
import UtilisationOverview from './utilisation/UtilisationOverview'
import PropertiesTabBar from './tab-bar/PropertiesTabBar'
import { useMemo } from 'react'
import LoadsOverview from './loads/LoadsOverview'

const propertyOptions = {
  cast_in_anchor_channel: () => <CastInAnchorChannelProperties />,
  t_bolt: () => <TboltProperties />,
}

const PropertiesContainer = () => {
  const design = useSelector((state: RootState) => state.activeDesign.design)
  const selectedComponentId = useSelector((state: RootState) => state.activeDesign.selectedComponentId)

  const { data: products, isFetching: isFetchingProducts } = useGetProductsQuery({
    perPage: 10000,
  })

  const { data: productVariants, isFetching: isFetchingProductVariants } = useGetProductVariantsQuery({
    perPage: 10000,
  })

  const isFetching = isFetchingProducts || isFetchingProductVariants

  const component = design?.components.find(c => c.id === selectedComponentId)
  const productVariant = productVariants?.data.find(p => p.id === component?.product_variant_id)
  const product = products?.data.find(p => p.id === productVariant?.product_id)

  const tabBarOptions = useMemo(() => {
    const options = ['Results', 'Loads']

    if (component) {
      options.push('Selected')
    }

    return options
  }, [component])

  if (isFetching) {
    return (
      <div className="flex items-center justify-center h-full">
        <LoadingSpinner className="w-4 h-4" />
      </div>
    )
  }

  return (
    <div className="pb-[20px] h-full">
      <PropertiesTabBar
        options={tabBarOptions}
        contents={[
          (
            <>
              {
                design
                && <UtilisationOverview design={design} />
              }
            </>
          ),
          (
            <>
              {
                design
                && <LoadsOverview design={design} />
              }
            </>
          ),
          (
            <div className="py-4" key="selected">
              {
                component?.type === 'concrete_slab'
                  ? <ConcreteProperties />
                  : propertyOptions[(product?.type ?? '') as keyof typeof propertyOptions]?.()
              }
            </div>
          ),
        ]}
      />
    </div>
  )
}

export default PropertiesContainer
